import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

const validateInstagram = (value: string): boolean => {
  const instagramRegex = /^@?[\w.]+$/;
  return instagramRegex.test(value) && value.length >= 3;
};

export const Step18_Instagram: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.instagram) {
      newErrors.instagram = 'Instagram/Rede Social é obrigatório';
    } else if (!validateInstagram(data.instagram)) {
      newErrors.instagram = 'Instagram inválido. Use o formato: @usuario ou usuario';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ instagram: data.instagram });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">📱 Qual seu Instagram/Rede Social?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Nos diga seu Instagram ou rede social principal. Isso nos ajuda a conhecer melhor seu perfil.
        </p>
      </div>
      <FormFieldGroup
        label="Instagram/Rede Social"
        required
        error={errors.instagram}
      >
        <input
          type="text"
          placeholder="@seu_usuario"
          value={data.instagram || ''}
          onChange={(e) => handleFieldChange('instagram', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step18_Instagram;
